import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.25 9.15C18.94 5.52 15.56 3.43 12 3.43a9.682 9.682 0 0 0-5.09 1.49 13.354 13.354 0 0 0-4.16 4.23 5.771 5.771 0 0 0 0 5.69c2.31 3.64 5.69 5.72 9.25 5.72a9.682 9.682 0 0 0 5.09-1.49 13.354 13.354 0 0 0 4.16-4.23 5.771 5.771 0 0 0 0-5.69ZM12 16.04A4.04 4.04 0 1 1 16.04 12 4.035 4.035 0 0 1 12 16.04Z",
      opacity: ".24"
    }, null, -1),
    _createElementVNode("path", {
      "data-name": "Vector",
      d: "M12 9.14A2.855 2.855 0 1 0 14.86 12 2.857 2.857 0 0 0 12 9.14Z"
    }, null, -1)
  ]))]))
}
export default { render: render }